module.exports = "https://coinrabbit.io/_next/static/images/card_1-icon-723aa20be0a066b74cc8d7f8d9989dac.svg";